import { prepareHttpHeaders } from "../utils/http";
import env from "../utils/env";

function getFlowRequest(formState) {
  // Exclude certain fields when a specified condition is met.
  // NOTE: This list has nothing to do with the conditionals we receive from the back-end.
  const conditionalBlacklist = [
    // Drop the fields 'request_date' and 'request_dt' when the field 'mode' is set to 'OND'.
    {
      fieldName: "mode",
      value: "OND",
      dropFields: ["request_date", "request_dt"]
    },
    {
      fieldName: "provider_id",
      value: "Next Available",
      dropFields: ["provider_id"]
    },
    {
      fieldName: "return_back",
      value: undefined,
      dropFields: ["return_back_url"]
    }
  ];
  // A list of filter functions. A function returns 'true' to keep the field, 'false' to exclude.
  const filters = [
    ([_, value]) => value !== "", // drop fields that are set to an empty string
    // eslint-disable-next-line max-len
    ([_, value]) => !(value && value.value === ""), // drop fields that are set to a "null option" (e.g. `{ value: "", text: "" }`)
    ([key]) => !key.startsWith("__"), // drop auxiliary fields that start with '__'
    ...conditionalBlacklist.map(
      ({ fieldName, value, dropFields }) =>
        ([key]) =>
          !(formState[fieldName] === value && dropFields.includes(key))
    )
  ];
  // The fields that should never be excluded/filtered out. Basically, a whitelist.
  const exceptions = [
    "email_address", // optional for under kids under 18 years old
    "pcp.provider_id", // primary care physician
    // AccountProfileEditViewController
    "address_line2",
    "phone_faxes.0.extension",
    "phone_faxes.1.extension"
  ];
  return Object.entries(formState).reduce((result, entry) => {
    const [key, value] = entry;
    return exceptions.includes(key) || filters.every(filter => filter(entry))
      ? { ...result, [key]: value }
      : result;
  }, {});
}

export function getRawFlow({ url, formState, translations, abortController }) {
  const config = {
    method: "POST",
    headers: prepareHttpHeaders({}, false, true),
    body: JSON.stringify(getFlowRequest(formState))
  };
  if (abortController) {
    config.signal = abortController.signal;
  }
  return fetch(env("BASE_URL") + url, config).then(res => {
    if (!res.ok && res.status !== 400) {
      if (res.status === 401) {
        throw new Error(
          translations && translations.auth_error_message
            ? translations.auth_error_message
            : "Authentication error, please try logging out and then try again."
        );
      } else {
        throw new Error(
          translations && translations.server_error_message
            ? translations.server_error_message.replace(
                "%phone_number%",
                translations?.callcenter_phone_num
              )
            : "An unknown server error occurred."
        );
      }
    }
    return res;
  });
}

export function getFlow({ url, formState, translations, abortController }) {
  return getRawFlow({
    url,
    formState,
    translations,
    abortController
  })
    .then(res => res.json())
    .then(data => {
      if (data.error && !(data.errors && data.errors.length)) {
        throw new Error(data.error);
      }
      return data;
    });
}
